module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/forget-password/forget-password.component.css
// module id = ./src/app/auth/forget-password/forget-password.component.css
// module chunks = main